module.exports = __webpack_public_path__ + "media/images/logo6-42493f9d.png";